import { Colors } from './'

const theme: Colors = {
  primary: '#61dafb',
  dark: '#133046',
  red: '#C7402D',
  white: '#FAFAFA',
  gray: '#EAEAEA',
  black: '#333',
}

export default theme
